import { render, staticRenderFns } from "./TenderCriteria.vue?vue&type=template&id=64a47e40"
import script from "./TenderCriteria.vue?vue&type=script&lang=js"
export * from "./TenderCriteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports